/** Who receives what → left-hand staff list with search; shows whether each person has a mobile/email on file. */
import React, { useState } from 'react';
import { Mail, Phone, Search, Shield } from 'lucide-react';

const ROLE = { admin: 'Admin', manager: 'Manager', team: 'Team' };

export function PersonPicker({ people, selected, onSelect }) {
  const [q, setQ] = useState('');
  const list = (people || []).filter((p) => !q || (p.name || '').toLowerCase().includes(q.toLowerCase()) || (p.email || '').includes(q.toLowerCase()));
  return (
    <div className="bg-white rounded-xl border overflow-hidden" data-testid="people-picker">
      <div className="p-2 border-b">
        <label className="relative block">
          <Search className="w-4 h-4 text-gray-400 absolute left-2.5 top-2.5" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search team…" className="h-9 w-full rounded-md border bg-gray-50 pl-8 pr-2 text-sm" data-testid="people-search" />
        </label>
      </div>
      <ul className="max-h-[70vh] overflow-y-auto divide-y">
        {list.map((p) => (
          <li key={p.user_id}>
            <button type="button" onClick={() => onSelect(p.user_id)} className={`w-full text-left px-3 py-2.5 flex items-center gap-3 hover:bg-violet-50 ${selected === p.user_id ? 'bg-violet-100/70' : ''}`} data-testid={`people-row-${p.user_id}`}>
              <span className="w-8 h-8 rounded-full bg-gray-900 text-white text-xs font-bold flex items-center justify-center shrink-0">{(p.name || '?').split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase()}</span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-gray-900 truncate">{p.name}</span>
                <span className="block text-[11px] text-gray-500 inline-flex items-center gap-2">
                  {ROLE[p.role] || p.role}{p.profit_access && <Shield className="w-3 h-3 text-violet-600" title="Profit access" />}
                  <Phone className={`w-3 h-3 ${p.phone ? 'text-emerald-600' : 'text-gray-300'}`} title={p.phone || 'No mobile saved'} />
                  <Mail className={`w-3 h-3 ${p.email ? 'text-emerald-600' : 'text-gray-300'}`} title={p.email || 'No email'} />
                </span>
              </span>
            </button>
          </li>
        ))}
        {!list.length && <li className="px-3 py-6 text-center text-xs text-gray-400">No one matches</li>}
      </ul>
    </div>
  );
}
